<template>
  <div class="video-description">
    <div>公開日：{{ video.createDate }}</div>
    <div v-html="video.desc"></div>
  </div>
</template>
<script>

export default {
  props: {
    video: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style scoped>
.video-description {
  background-color: #0000000d;
  border-radius: 8px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/VideoDescription.vue